const stripTags = require("./stripTags.js");
module.exports = function getLineCount(text){
    return text.split("</p>").filter(textLine => {
        return stripTags(textLine).trim() !== "";
    }).length;
}